var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutubePlatform = function SvgYoutubePlatform(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75688 23.2918C2.2792 22.8914 1.1275 21.7138 0.701226 20.2612C0 17.5817 0 11.9961 0 11.9961C0 11.9961 0 6.41133 0.701226 3.75688C1.12663 2.2792 2.2792 1.12663 3.75688 0.726301C6.41133 0 17.1303 0 17.1303 0C17.1303 0 27.8744 0 30.5288 0.726301C32.0316 1.12663 33.1582 2.2792 33.5594 3.75688C34.2857 6.41133 34.2857 11.9961 34.2857 11.9961C34.2857 11.9961 34.2857 17.5808 33.5594 20.2612C33.1582 21.7138 32.0316 22.8906 30.5288 23.2918C27.8744 24.0181 17.1303 24.0181 17.1303 24.0181C17.1303 24.0181 6.41133 24.0181 3.75688 23.2918ZM13.7245 17.1554L22.6156 11.9961L13.7245 6.86181V17.1554Z",
    fill: "#FF0033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7245 17.1554L22.6156 11.9961L13.7245 6.86181V17.1554Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubePlatform);
export default ForwardRef;